import styled from "@yb/styled-px2rem";
import imgButton from "@PUBLIC/M/images/btn/btn_spr.png";

const Button = styled.button`
	display: block;
	width: 20px;
	height: 20px;
	background: url(${imgButton}) 0 -57px / 100px 100px;

	// &::after {
	// 	content: "";
	// 	display: block;
	// 	width: 2px;
	// 	height: 19px;
	// 	background-color: #000;
	// 	transform: rotate(-45deg) translate(6px, 1px);
	// 	left: 0;
	// }

	// span {
	// 	position: absolute;
	// 	width: 1px;
	// 	height: 1px;
	// 	padding: 0;
	// 	margin: -1px;
	// 	border: none;
	// 	clip: rect(0 0 0 0);
	// 	overflow: hidden;
	// 	font-size: 15px;
	// 	scroll-behavior: smooth;
	// }
`;

const BackButton = props => (
	<Button {...props}>
		<span>뒤로가기</span>
	</Button>
);

export default BackButton;
